import React from 'react'
import { Icon, IconName } from '~components/Icon'
import { InputProps, CustomInputProps } from './TextualFormElement.types'
import InputBase from './InputBase'
import InputPassword from './InputPassword'

export type ComponentProps = CustomInputProps & InputProps

const Input: React.FC<ComponentProps> = React.forwardRef<HTMLInputElement, ComponentProps>(({ icon, iconRight, size, type, ...inputProps }, ref) => {
  let iconName = icon

  if (type === 'search') {
    iconName = icon || IconName.search
  }

  if (type === 'password') {
    return <InputPassword ref={ref} size={size} icon={icon} iconRight={iconRight} {...inputProps} />
  }

  return (
    <InputBase
      prefixElement={iconName && <Icon name={iconName} size={size} />}
      suffixElement={iconRight && <Icon name={iconRight} size={size} />}
      ref={ref}
      type={type}
      size={size}
      {...inputProps}
    />
  )
})

Input.displayName = 'Input'
export default Input
